import { styled } from 'stitches.config'

export const FrozenRecipeRoot = styled('div', {
    
})